<template lang="pug">
  div.wrap-module-payment-card-registration.f.fh(v-if="!!trainee")
    NowLoading(:show="showNowLoading")
    div.module-payment-card-registration-content
      //- Select course
      div(v-if="viewType == VIEW_TYPE_SELECT_COURSE").wrap-payment-method
        span.block.text-center.bold.mb16 コースを選択
        div.about-plan.mb10
          span.block.text-center.mb4 受講するコースを選択してください
          div.f.fc
            v-radio-group(v-model="course")
              v-radio(value="advanced_course" dark color="#008594")
                template(slot="label")
                  div
                    div アドバンスコース / Advanced Course
                    div.text-small 入学金33,000円 + 受講料132,000円（内税）
              v-radio(value="basic_course" dark color="#008594")
                template(slot="label")
                  div
                    div ベーシックコース / Basic Course
                    div.text-small 入学金33,000円 + 受講料66,000円（内税）
        v-btn.next-button(@click="goToSelectPaymentMethodView" width="100%" color="#008594").mb24 次へ
        span.fz12.block.text-center コースの詳細については#[a(href="https://www.healthcarecatalyst.org/college" target="_blank").here-link こちら]をご確認ください

      //- Select payment method
      div(v-if="viewType == VIEW_TYPE_SELECT_PAYMENT_METHOD").wrap-payment-method
        //- span.block.text-center.bold.mb4 カード決済によるお支払い回数を選択
        //- span.block.text-center.bold.mb16 (アドバンスコース / Advanced Course)
        span.block.text-center.bold.mb16 カード決済によるお支払い回数を選択
        div.about-plan.mb10
          //- span.block.text-center.mb4 {{`入学金${entranceFee.toLocaleString()}円＋受講料${lessonFee.toLocaleString()}円（内税）`}}
          span.block.text-center.mb12 受講料のみ一括か分割かをお選びいただけます
          span.block.text-center.mb4.fz12 * 一括支払いの場合、入学金が{{discountedLessonFeeByOneTime.toLocaleString()}}円割引となります
          div.f.fc
            v-radio-group(v-model="paymentMethod")
              v-radio(:label="`受講料一括支払い：${lessonFee.toLocaleString()}円`" :value="PAYMENT_METHOD_ONE_TIME"
                dark color="#008594")
              v-radio(:label="`受講料分割支払い：${lessonFeePerMonth.toLocaleString()}円 x 12回`" :value="PAYMENT_METHOD_MONTHLY"
                dark color="#008594")
          span(v-if="paymentMethod").block.text-center.mb24.bold {{`入学金${entranceFee.toLocaleString()}円＋受講料${lessonFee.toLocaleString()}円（内税）`}}
        v-btn.next-button(@click="goToInputCreditCardView" width="100%" color="#008594").mb24 次へ
        //- basic_courseは一度隠しておく
        div.f.fc.mb24
          span(@click="backToSelectCourseView").back 戻る
        span.fz12.block.text-center.mb2 銀行振り込みによるお支払いを
        span.fz12.block.text-center ご希望の方は#[a(href="mailto:hcc.info@deportare.tech?subject=[HCC]学費の決済方法についての問合せ").here-link こちら]までお問い合わせください

      //- Input credit card
      div(:style="(viewType == VIEW_TYPE_INPUT_CREDIT_CARD) ? '' : 'display:none;'")
        div.mb24
          span.block.text-center.bold.mb12(v-if="isRetry") {{retryTitle}}
          span.block.text-center.bold.mb12(v-else) カード登録
        div.wrap-card-info.mb8
          span.block.mb20.fz12(v-if="isRetry") {{retryMessage}}
          div.custom-input-group
            span.label(for="card-number") カード番号
            div.input(id="card-number")
            //- hint="対応カード：Visa,Mastercard,American Express,Discover,Diners Club,JCB")
          v-text-field(label="名義"
            v-model="cardHolderName"
            :placeholder="isCreditCardInputMounted ? 'Taro Yamada' : ' '"
            dark color="#fff")
          div.f
            div.expiration.mr12
              div.custom-input-group
                span.label(for="card-expiry") 有効期限
                div.input(id="card-expiry")
            div.cvv
              div.custom-input-group
                span.label(for="card-cvv") セキュリティーコード
                div.input(id="card-cvv")
        div.wrap-coupon-code.mb30(v-if="!trainee.paidEntranceFee")
          span(v-if="!shouldInputCouponCode"
            @click="shouldInputCouponCode = !shouldInputCouponCode"
            ).toggle-coupon-form.cta-text.text-center.block.fz14 クーポンコードをお持ちの方
          v-text-field(v-else
            v-model="couponCode"
            label="クーポンコード"
            placeholder="coupon_code"
            :hint="couponDescriptions[couponCode]"
            persistent-hint
            @input="handleChangeCouponCode"
            dark color="#fff")
        v-btn.next-button(@click="goToConfirmingView" width="100%"
          color="#008594" dark).mb20 確認
        div.mt12(v-if="isRetry && !isChangeCard")
          span.fz12.block.text-center.mb2 カードの利用ができない場合は
          span.fz12.block.text-center.mb2 銀行振り込みによるお支払いにも対応できます。
          span.fz12.block.text-center ご希望の方は#[a(href="mailto:hcc.info@deportare.tech?subject=[HCC]学費の決済方法についての問合せ（カード支払いによる決済ができない場合）").here-link こちら]までお問い合わせください
        div.f.fc(v-if="!isRetry")
          span(@click="backToSelectPaymentMethodView").back 戻る

      //- Confirm
      div(v-if="viewType == VIEW_TYPE_CONFIRM").wrap-confirm
        span.block.text-center.bold.mb16 お支払い内容のご確認
        div.about-plan.mb30
          span.block.mb4 {{confirmFeeLabel}}
          span.block.mb4(v-if="!trainee.paidLessonFee && !isChangeCard") お支払い方法：{{(paymentMethod == PAYMENT_METHOD_ONE_TIME) ? '受講料一括支払い' : '受講料分割支払い'}}
          span(v-if="couponDescriptions[couponCode]").block.mb4 クーポン：{{ couponDescriptions[couponCode] }}
          span(v-if="couponDescriptions[couponCode]").block.mb4 クーポン割引金額：{{ coupons[couponCode].amount_off.toLocaleString() }}円
          span.block.mb4 {{confirmFinalFeeLabel}}
        v-btn.next-button(@click="submitCardInfo" width="100%"
          color="#008594" dark).mb20 {{ submitCardInfoButtonTitle }}
        div.f.fc
          span(@click="backToInputingView").back 戻る
      div.wrap-sign-out
        span(@click="logout").sign-out.block.text-center.fz14.cursor-pointer サインアウト

</template>

<style lang="scss">
.wrap-module-payment-card-registration {
  span {
    color: #fff;
  }
  .here-link {
    color: #008594;
  }
  .v-input {
    caret-color: #919191 !important;
    color: #919191 !important;
    .v-label {
      color: #fff !important;
    }
  }
  .v-input {
    .v-radio {
      .v-label {
        color: #fff !important;
        font-size: 14px;
        .text-small {
          font-size: 12px;
        }
      }
    }
  }
  .custom-input-group {
    margin-bottom: 20px;
    .label {
      color: #fff !important;
      font-size: 12px;
    }
    .input {
      margin-bottom: 6px;
      height: 26px;
      border-bottom: 1px solid rgba(255,255,255,0.7);
    }
  }
}
</style>
<style lang="scss" scoped>
.wrap-module-payment-card-registration {
  position: relative;
  width: 100%;
  height: 100vh;
  .module-payment-card-registration-content {
    min-width: 280px;
    .wrap-payment-method {
      .about-plan > span {
        // margin: 16px 0px;
        input {
          margin-left: 12px;
        }
      }
    }
    .wrap-card-info {
      width: 280px;
      .expiration {
        width: 60px;
      }
      .cvv {
        margin-left: 12px;
        width: 50%;
      }
    }
    .wrap-coupon-code {
      .toggle-coupon-form {
        color: #008594;
      }
    }
  }
  .next-button {
    color: white;
    background-color: #2a2a2a;
    margin: 0;
    width: 100%;
    border-radius: 4px;
  }
  .wrap-sign-out {
    position: absolute;
    width: 100%;
    bottom: 22px;
    left: 0;
  }
}
</style>

<script>
import { requests } from '@/components/utils/requests'
import { stripeKey } from '@/components/utils/firebase'
import { debounce } from '@/components/utils/utils'
import { createNamespacedHelpers } from 'vuex'
const {
  mapState: mapStateAuth,
  mapActions: mapActionsAuth
} = createNamespacedHelpers('auth')
import NowLoading from '@/components/shared/NowLoading'
import { database } from '@shared/database'
const stripe = Stripe(stripeKey)

const PAYMENT_METHOD_ONE_TIME = 'one_time'
const PAYMENT_METHOD_MONTHLY = 'monthly'

const VIEW_TYPE_SELECT_COURSE = 'select_course'
const VIEW_TYPE_SELECT_PAYMENT_METHOD = 'select_payment_method'
const VIEW_TYPE_INPUT_CREDIT_CARD = 'input_credit_card'
const VIEW_TYPE_CONFIRM = 'confirm'

export default {
  components: {
    NowLoading
  },
  computed: {
    ...mapStateAuth(['uid']),
    saleOffAmount: function() {
      // (coupons[couponCode] && coupons[couponCode].amount_off) ? (165000 - coupons[couponCode].amount_off) : '165,000'
      if (this.coupons[this.couponCode]) {
        const coupon = this.coupons[this.couponCode]
        if (coupon.amount_off) {
          return coupon.amount_off
        } else {
          let amount = Math.floor(coupon.percent_off / 100 * this.entranceFee)
          return amount
        }
      } else {
        return 0
      }
    },
    retryTitle() {
      if (this.isChangeCard) {
        return 'カードの再登録&お支払い'
      } else if (this.trainee && this.isRetry) {
        if (!this.trainee.paidEntranceFee && !this.trainee.paidLessonFee) {
          return `入学金と受講料のお支払い`
        } else if (!this.trainee.paidEntranceFee) {
          return `入学金のお支払い`
        } else if (!this.trainee.paidLessonFee) {
          return `受講料のお支払い`
        }
      }
      
      return ''
    },
    retryMessage() {
      if (this.isChangeCard) {
        return 'ご登録いただいた受講料（分割支払い）のお支払いに失敗しました。受講を継続するにはお支払いが有効なカードの再登録をお願いします。再登録いただいたカードにて、残りの分割支払いを再開いたします'
      } else if (this.trainee && this.isRetry) {
        if (!this.trainee.paidEntranceFee && !this.trainee.paidLessonFee) {
          return `入学金と受講料のお支払いに失敗しました。カード会社にご連絡いただくか、他のカードをお使いください`
        } else if (!this.trainee.paidEntranceFee) {
          return `受講料のお支払いは成功しましたが、入学金のお支払いに失敗しました。ご利用のカード会社にご連絡いただくか、他のカードをお使いください`
        } else if (!this.trainee.paidLessonFee) {
          return `入学金のお支払いは成功しましたが、受講料のお支払いに失敗しました。ご利用のカード会社にご連絡いただくか、他のカードをお使いください`
        }
      }
      
      return ''
    },
    confirmFeeLabel() {
      if (this.isChangeCard) {
        return `残りの分割支払い：${this.lessonFeePerMonth.toLocaleString()}円 × ${this.needToBePaidMonthsLeft || 12}回`
      } else if (this.trainee && this.isRetry) {
        if (!this.trainee.paidEntranceFee && !this.trainee.paidLessonFee) {
          // fallback to default
        } else if (!this.trainee.paidEntranceFee) {
          return `入学金：${this.entranceFee.toLocaleString()}円（内税）`
        } else if (!this.trainee.paidLessonFee) {
          return `受講料：${(this.lessonFeePerMonth * (this.needToBePaidMonthsLeft || 12)).toLocaleString()}円（内税）`
        }
      }
      
      return `入学金+受講料：${(this.entranceFee + this.lessonFee).toLocaleString()}円（内税）`
    },
    confirmFinalFeeLabel() {
      if (this.trainee && this.isRetry) {
        if (!this.trainee.paidEntranceFee && !this.trainee.paidLessonFee) {
          // fallback to default
        } else if (!this.trainee.paidEntranceFee) {
          return `合計：${(this.entranceFee - this.saleOffAmount).toLocaleString()}円（内税）`
        } else if (!this.trainee.paidLessonFee) {
          return `合計：${(this.lessonFeePerMonth * (this.needToBePaidMonthsLeft || 12)).toLocaleString()}円（内税）`
        }
      }
      
      return `合計：${(this.entranceFee + this.lessonFee - this.saleOffAmount).toLocaleString()}円（内税）`
    },
    submitCardInfoButtonTitle() {
      if (this.isChangeCard) {
        return 'カードの再登録&お支払いの再開'
      }

      return '購入'
    },
    entranceFee() {
      if (this.paymentMethod === 'one_time') {
        return (this.course === 'basic_course') ? 30000 : 27000
      } else {
        return 33000
      }
    },
    lessonFeePerMonth() {
      return (this.course === 'basic_course') ? 5500 : 11000
    },
    lessonFee() {
      return (this.course === 'basic_course') ? 66000 : 132000
    },
    discountedLessonFeeByOneTime () {
      return (this.course === 'basic_course') ? 3000 : 6000
    },
    urlParams() {
      let result
      if (this.$route.query) {
        result = '?'
        for (const [key, value] of Object.entries(this.$route.query)) {
          result = result + `&${key}=${value}`
        }
        result = result.replace('&', '') // はじめの&だけ取り除く
      } else {
        result = ''
      }
      return result
    }
  },
  data() {
    let couponCode =
      (this.$route.params || {}).couponCode || this.$store.state.couponCode

    if (couponCode) {
      // handleChangeCouponCode function should be run after we have couponCode from `data()` function
      setTimeout(() => {
        this.handleChangeCouponCode()
      }, 100)
    }

    return {
      unsubscribe: null,
      trainee: null,
      isRetry: false,
      isChangeCard: false,
      stripeTokenId: null,
      isCreditCardInputMounted: false,
      // cardNumber: '',
      cardNumberError: 'カード番号をご確認ください',
      cardHolderName: '',
      // cardExpirationDate: '',
      cardExpirationDateError: '有効期限をご確認ください',
      // cardCvv: '',
      cardCvvError: 'CVVをご確認ください',
      shouldInputCouponCode: !!couponCode,
      couponCode: couponCode || '',
      couponDescriptions: {},
      coupons: {},
      focusElementStyle: null,
      isInputFocused: false,
      canInput: true,
      isValid: false,
      showNowLoading: false,
      // basic_courseは一度隠しておく
      viewType: VIEW_TYPE_SELECT_COURSE,
      course: null,
      // viewType: VIEW_TYPE_SELECT_PAYMENT_METHOD,
      // course: 'advanced_course',
      paymentMethod: null,
      PAYMENT_METHOD_ONE_TIME,
      PAYMENT_METHOD_MONTHLY,
      VIEW_TYPE_SELECT_COURSE,
      VIEW_TYPE_SELECT_PAYMENT_METHOD,
      VIEW_TYPE_INPUT_CREDIT_CARD,
      VIEW_TYPE_CONFIRM,
      needToBePaidMonthsLeft: null,
    }
  },
  mounted() {
    console.log('Firebase user: ', this.uid)
    this.unsubscribe = database.onTraineeUpdated(this.uid, (trainee) => {
      const isOpeningPage = !this.trainee
      this.trainee = trainee

      if (isOpeningPage) {
        if (trainee.paidEntranceFee && trainee.paidLessonFee) {
          console.log('Payment is successful', {isOpeningPage})
          this.$router.push(this.getToPath('application-survey'))
        } else if (trainee.paidEntranceFee !== undefined || trainee.paidLessonFee !== undefined) {
          console.log('Payment is failed', {isOpeningPage})
          this.isRetry = true
          this.isChangeCard = trainee.paidEntranceFee && !trainee.paidLessonFee && trainee.paymentMethod === PAYMENT_METHOD_MONTHLY
          this.viewType = VIEW_TYPE_INPUT_CREDIT_CARD
          this.setupCardForm()
          this.course = trainee.course || 'advanced_course'
          this.paymentMethod = trainee.paymentMethod

          if (trainee.stripeSubscriptionId) {
            requests.getNeedToBePaidMonthsLeft({
              stripeSubscriptionId: trainee.stripeSubscriptionId
            })
            .then((value) => {
              this.needToBePaidMonthsLeft = value.needToBePaidMonthsLeft
            })
          }
        }
      } else {
        if (trainee.paidEntranceFee && trainee.paidLessonFee) {
          console.log('Payment is successful', {isOpeningPage})
          if (this.showNowLoading) {
            alert('購入が完了しました')
          }
          this.showNowLoading = false
          if (this.needToBePaidMonthsLeft && this.needToBePaidMonthsLeft < 12) {
            this.$router.push(this.getToPath('card-registration-complete'))
          } else {
            this.$router.push(this.getToPath('application-survey'))
          }
        } else if ((trainee.paidEntranceFee === false && trainee.paidLessonFee !== null)
          || (trainee.paidEntranceFee !== null && trainee.paidLessonFee === false)) {
          console.log('Payment is failed', {isOpeningPage})
          if (this.showNowLoading) {
            alert('カードの情報をご確認ください')
          }
          this.showNowLoading = false
        }
      }
    })
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe()
      this.unsubscribe = null
    }
  },
  watch: {
    cardHolderName(newText, oldText) {
      this.stripeTokenId = null
    }
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    logout() {
      this.signOut()
      setTimeout(this.toSignInPage, 400)
    },
    toSignInPage() {
      this.$router.push('/sign-in')
    },
    getToPath(name) {
      if (this.course && this.urlParams) {
        return `/${name}/${this.course}${this.urlParams}`
      }
      if (this.course) {
        return `/${name}/${this.course}`
      }
      if (this.urlParams) {
        return `/${name}${this.urlParams}`
      }
      return `/${name}`
    },
    setupCardForm() {
      if (this.isCreditCardInputMounted) {
        return
      }

      setTimeout(() => {
        var style = {
          base: {
            fontFamily: 'Helvetica',
            fontSize: '16px',
            color: 'white',
          }
        }

        var elements = stripe.elements({
          locale: 'ja',
        })

        // card-number
        this.cardNumberElement = elements.create('cardNumber', {
          style,
          placeholder: '0000 0000 0000 0000',
        })
        this.cardNumberElement.on('ready', () => {
          this.isCreditCardInputMounted = true
        })
        this.cardNumberElement.on('change', (data) => {
          let errorMessage = null
          if (data.empty) {
            errorMessage = 'カード番号をご確認ください'
          } else if (data.error) {
            errorMessage = data.error.message
          }
          this.stripeTokenId = null
          this.cardNumberError = errorMessage
        })
        this.cardNumberElement.mount('#card-number')

        // card-expiry
        this.cardExpiryElement = elements.create('cardExpiry', {
          style,
          placeholder: 'mm/yy',
        })
        this.cardExpiryElement.on('change', (data) => {
          let errorMessage = null
          if (data.empty) {
            errorMessage = '有効期限をご確認ください'
          } else if (data.error) {
            errorMessage = data.error.message
          }
          this.stripeTokenId = null
          this.cardExpirationDateError = errorMessage
        })
        this.cardExpiryElement.mount('#card-expiry')

        // card-cvc
        this.cardCvvElement = elements.create('cardCvc', {
          style,
          placeholder: '0000',
        })
        this.cardCvvElement.on('change', (data) => {
          let errorMessage = null
          if (data.empty) {
            errorMessage = 'CVVをご確認ください'
          } else if (data.error) {
            errorMessage = data.error.message
          }
          this.stripeTokenId = null
          this.cardCvvError = errorMessage
        })
        this.cardCvvElement.mount('#card-cvv')
      }, 200)
    },
    async goToSelectPaymentMethodView() {
      if (!this.course) {
        alert('コースをご選択ください')
        return
      }
      this.viewType = VIEW_TYPE_SELECT_PAYMENT_METHOD
      this.setupCardForm()
    },
    async goToInputCreditCardView() {
      if (!this.paymentMethod) {
        alert('お支払い回数をご選択ください')
        return
      }
      this.viewType = VIEW_TYPE_INPUT_CREDIT_CARD
      this.setupCardForm()
    },
    handleChangeCouponCode: debounce(async function() {
      const couponCode = this.couponCode
      if (couponCode && !this.couponDescriptions[couponCode]) {
        const coupon = await requests.getCoupon(couponCode).catch(() => {})

        if (coupon) {
          this.couponDescriptions = {
            ...this.couponDescriptions,
            [couponCode]: coupon['name']
          }
          this.coupons = {
            ...this.coupons,
            [couponCode]: coupon
          }
        }
      }
    }, 200),
    async goToConfirmingView() {
      if (this.cardNumberError) {
        alert(this.cardNumberError)
        return
      }

      if (!this.cardHolderName) {
        alert('名義をご入力ください')
        return
      }

      if (this.cardExpirationDateError) {
        alert(this.cardExpirationDateError)
        return
      }

      if (this.cardCvvError) {
        alert(this.cardCvvError)
        return
      }

      this.isValid = true
      this.showNowLoading = true

      if (!this.stripeTokenId) {
        const result = await stripe.createToken(this.cardNumberElement, {
          name: this.cardHolderName,
        })
        .catch((error) => {
          this.isValid = false
          if (error['message']) {
            alert(error['message'])
          } else {
            alert('カードの情報をご確認ください')
          }
        })

        if (result) {
          this.stripeTokenId = result.token.id
        }

        // const stripeToken = await requests
        //   .createCreditCardToken({
        //     cardNumber: this.cardNumber,
        //     cardHolderName: this.cardHolderName,
        //     cardExpMonth:
        //       this.cardExpirationDate[0] + this.cardExpirationDate[1],
        //     cardExpYear:
        //       this.cardExpirationDate[3] + this.cardExpirationDate[4],
        //     cardCvv: this.cardCvv
        //   })
        //   .catch((error) => {
        //     this.isValid = false
        //     if (error['code'] === 'invalid-argument' && error['message'] !== 'INTERNAL') {
        //       alert(error['message'])
        //     } else {
        //       alert('カードの情報をご確認ください')
        //     }
        //   })

        // if (stripeToken) {
        //   this.stripeTokenId = stripeToken['id']
        // }

        if (!this.isValid) {
          this.showNowLoading = false
          return
        }
      }

      if (this.shouldInputCouponCode && this.couponCode) {
        const couponCode = this.couponCode // this.couponCode can be changed when we're requesting to server

        if (!this.couponDescriptions[couponCode]) {
          const coupon = await requests.getCoupon(couponCode).catch(() => {
            this.isValid = false
            alert('クーポンコードは正しくありません')
          })

          if (coupon) {
            this.couponDescriptions = {
              ...this.couponDescriptions,
              [couponCode]: coupon['name']
            }
            this.coupons = {
              ...this.coupons,
              [couponCode]: coupon
            }
          }

          if (!this.isValid) {
            this.showNowLoading = false
            return
          }
        }
      }

      this.showNowLoading = false
      this.viewType = VIEW_TYPE_CONFIRM
    },
    async backToSelectCourseView() {
      this.viewType = VIEW_TYPE_SELECT_COURSE
    },
    async backToSelectPaymentMethodView() {
      this.viewType = VIEW_TYPE_SELECT_PAYMENT_METHOD
    },
    async backToInputingView() {
      this.viewType = VIEW_TYPE_INPUT_CREDIT_CARD
      this.setupCardForm()
    },
    async submitCardInfo() {
      this.showNowLoading = true

      if (!this.stripeTokenId) {
        const result = await stripe.createToken(this.cardNumberElement, {
          name: this.cardHolderName,
        })
        .catch((error) => {
          if (error['message']) {
            alert(error['message'])
          } else {
            alert('カードの情報をご確認ください')
          }
          this.showNowLoading = false
          return
        })

        if (result) {
          this.stripeTokenId = result.token.id
        }
      }

      await requests
        .createSubscription({
          course: this.course,
          paymentMethod: this.paymentMethod,
          cardTokenId: this.stripeTokenId,
          // cardNumber: this.cardNumber,
          // cardHolderName: this.cardHolderName,
          // cardExpMonth: this.cardExpirationDate[0] + this.cardExpirationDate[1],
          // cardExpYear: this.cardExpirationDate[3] + this.cardExpirationDate[4],
          // cardCvv: this.cardCvv,
          couponCode: this.couponCode
        })
        .then(() => {
          // this is processed on mounted() function
          // alert('購入が完了しました')
          // this.$router.push('/application-survey')
        })
        .catch(() => {
          alert('お支払いに失敗しました')
          this.showNowLoading = false
        })
        .finally(() => {
          // card-token is usable for 1 time only, so we need clear this
          this.stripeTokenId = null
        })
    }
  }
}
</script>
